<template>
  <!-- 竖屏时 -->
  <div v-if="$store.state.app.isPortrait">
    <div class="land-topbar">
      <div class="time">{{ timer }}</div>
      <div class="date">{{ $moment(date).format('YYYY-MM-DD') }}</div>
      <div v-if="buildInfo.city" class="address">
        <span class="city"><i class="el-icon-location-outlin"></i>{{ buildInfo.city + ',' + buildInfo.county }}</span>
        <span class="wea">{{ wea ? wea : '' }}</span>
        <span class="tem">{{ tem ? tem + '℃' : '' }}</span>
      </div>
      <div v-else class="noaddress">暂无位置信息</div>
      <div class="deviceId">设备编号：{{ deviInfo.deviceId || '- -' }}</div>
    </div>
    <div class="land-topbar-title">
      <img :src="baseSettingInfo.basiSetting ? baseSettingInfo.basiSetting.imageLogo ? baseSettingInfo.basiSetting.imageLogo : '/images/preloader/logo.png' : '/images/preloader/logo.png' " alt="logo">
      <div class="m-l-24">{{ baseSettingInfo.basiSetting ? baseSettingInfo.basiSetting.buildName : '医路航导航导诊大屏' }}</div>
    </div>
  </div>
  <!-- 横屏时 -->
  <div v-else class="wrap-topbar">
    <div class="left">
      <img :src="baseSettingInfo.basiSetting ? baseSettingInfo.basiSetting.imageLogo ? baseSettingInfo.basiSetting.imageLogo : '/images/preloader/logo.png' : '/images/preloader/logo.png' " alt="">
      <div class="title">{{ baseSettingInfo.basiSetting ? baseSettingInfo.basiSetting.buildName : '医路航导航导诊大屏' }}</div>
    </div>
    <div class="right">
      <div v-if="buildInfo.city" class="address">
        <span>{{ buildInfo.city + ',' + buildInfo.county }}</span>
        <span>{{ wea ? ',' + wea : '' }}</span>
        <span>{{ tem ? tem + '℃' : '' }}</span>
      </div>
      <div v-else class="address">暂无位置信息</div>
      <div class="date">{{ dateStr }}</div>
      <div class="deviceId">设备编号：{{ deviInfo.deviceId || '- -' }}</div>
    </div>
  </div>
</template>

<script>
const requestAnimationFrameSupported = window.requestAnimationFrame !== undefined;
export default {
  components: {

  },
  props: {

  },
  data () {
    return {
      date: new Date().getTime(),
      dateStr: this.$moment(new Date().getTime()).format('LL HH:mm:ss'),
      timer: this.$moment(new Date().getTime()).format('HH:mm'),
      opp: '',
      wea: null, // 天气
      tem: null // 温度
    };
  },
  computed: {
    // // 建筑信息
    // isPortrait () {
    //   console.log(this.$store.state.app.isPortrait)
    //   return this.$store.state.app.isPortrait;
    // },
    buildLogo () {
      return this.$store.state.nav.buildLogo;
    },
    buildInfo () {
      return this.$store.state.nav.buildInfo;
    },
    deviInfo () {
      return this.$store.state.app.deviInfo;
    },
    baseSettingInfo () {
      return this.$store.state.app.baseSettingInfo;
    }
  },
  watch: {
  },
  created () {
    this.updateTime();
    this.fetchWeather();
  },
  mounted () {
  },
  methods: {
    // 更新时间
    async updateTime () {
      if (requestAnimationFrameSupported) {
        requestAnimationFrame(() => {
          this.date = new Date().getTime();
          this.dateStr = this.$moment(this.date).format('LL HH:mm:ss');
          this.timer = this.$moment(this.date).format('HH:mm');
          this.updateTime(); // 递归调用
        });
      } else {
        setInterval(() => {
          this.date = new Date().getTime();
          this.dateStr = this.$moment(this.date).format('LL HH:mm:ss');
        }, 1000);
      }
    },
    // 获取天气、温度
    async fetchWeather () {
      let step = 60 * 60 * 1000;
      if (this.buildInfo.city) {
        let city = this.buildInfo.city.slice(0, this.buildInfo.city.length - 1);
        this.getTianqi(city);
      }
      // 定时获取天气、温度
      setInterval(() => {
        if (this.buildInfo.city) {
          let city = this.buildInfo.city.slice(0, this.buildInfo.city.length - 1);
          this.getTianqi(city);
        }
      }, step);
    },
    // 获取天气
    async getTianqi (city) {
      try {
        let res = await this.$apis.app.getTianqi({ version: 'v6', appid: 35789961, appsecret: 'ho4E7e0E', city });
        console.log('天气数据：', res);
        let data = JSON.parse(res.data);
        this.wea = data.weather;
        this.tem = data.temperature;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-topbar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  height: 70px;
  width: 100%;
  background: $color-opacity-primary;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $color-white;
  .left,
  .right {
    display: flex;
    align-items: center;
    padding: 0 120px 0 40px;
  }
  .right {
    font-size: 18px;
    & > div {
      margin: 0 0 0 50px;
    }
  }
  img {
    height: 40px;
  }
  .title {
    font-size: 26px;
    padding: 0 0 0 30px;
    margin: 0 0 0 30px;
    border-left: 1px solid #789d9b;
    text-indent: 50px;
  }
}

.land-topbar{
  font-family: PingFangSC, PingFang SC;
  display: flex;
  background: #306576;
  color: #fff;
  width: 100vw;
  height: 7.41vw;
  align-items: center;
  font-size: 2.22vw;
  box-sizing: border-box;
  padding: 1.39vw 2.96vw;
  overflow: hidden;
  .time{
    font-size: 2.96vw;
  }
  .date{
    font-size: 2.22vw;
    border-right: 0.09vw solid #e5e5e5;
    margin-left: 1.48vw;
    padding-right: 2.22vw;
  }
  .city{
    font-size: 2.22vw;
    margin-left: 2.22vw;
  }
  .noaddress {
    font-size: 2.22vw;
    margin-left: 2.22vw;
  }
  .tem{
   margin-left: 2.22vw;
   font-size: 2.22vw;
  }
  .deviceId {
    margin-left: 2.22vw;
    font-size: 2.22vw;
  }
}
.land-topbar-title{
  box-sizing: border-box;
  width: 100%;
  height: 7.41vw;
  font-family: PingFangSC, PingFang SC;
  color: #fff;
  font-size: 3.33vw;
  display: flex;
  align-items: center;
  padding-left: 2.22vw;
  overflow: hidden;
  img {
    width: 7.41vw;
  }
}
.m-l-24{
    margin-left: 24px;
  }
@media (orientation: portrait) {
}
@media (orientation: portrait) {
  .wrap-topbar {
    display: block;
    height: 160px;
  }
}
</style>
